import { UAPPlacementType as EPT } from '@bingads-webui-campaign-react/unified-ad-preview-library-core';
//
// this is the type returned from MT APIs, will map it to a placement type
export const UAPMediaPlacementType = {
  MultiMediaAd400X100: 'MultiMediaAd400X100',
  MultiMediaAd191X100: 'MultiMediaAd191X100',
  MultiMediaAd100X100: 'MultiMediaAd100X100',
  MultiMediaAd50X100: 'MultiMediaAd50X100',
  MSAN191X100: 'MSAN191X100',
  MSAN178X100: 'MSAN178X100',
  MSAN172X100: 'MSAN172X100',
  MSAN169X100: 'MSAN169X100',
  MSAN155X100: 'MSAN155X100',
  MSAN150X100: 'MSAN150X100',
  MSAN133X100: 'MSAN133X100',
  MSAN100X100: 'MSAN100X100',
  MSAN93X100: 'MSAN93X100',
  MSAN201X100: 'MSAN201X100',
  MSAN200X100: 'MSAN200X100',
  MSAN153X100: 'MSAN153X100',
  MSAN124X100: 'MSAN124X100',
  MSAN120X100: 'MSAN120X100',
  ImageExtension191X100: 'ImageExtension191X100',
  ImageExtension178X100: 'ImageExtension178X100',
  ImageExtension172X100: 'ImageExtension172X100',
  ImageExtension169X100: 'ImageExtension169X100',
  ImageExtension155X100: 'ImageExtension155X100',
  ImageExtension150X100: 'ImageExtension150X100',
  ImageExtension133X100: 'ImageExtension133X100',
  ImageExtension100X100: 'ImageExtension100X100',
  ImageExtension93X100: 'ImageExtension93X100',
  AssetGroup191X100: 'AssetGroup191X100',
  AssetGroup100X100: 'AssetGroup100X100',
  AssetGroup150X100: 'AssetGroup150X100',
  AssetGroup133X100: 'AssetGroup133X100',
  AssetGroup178X100: 'AssetGroup178X100',
  AssetGroup100X200: 'AssetGroup100X200',
  AssetGroup400X100: 'AssetGroup400X100',
};

// todo: not all values are mapped
// each multi-media placement type maps to a list of placement types
export const MediaPlacementTypeToPlacementTypeMap = {
  [UAPMediaPlacementType.MultiMediaAd400X100]: [EPT.MMA_WideImage_4x1],
  [UAPMediaPlacementType.MultiMediaAd191X100]: [EPT.MMA_LandscapeImage_191x100],
  [UAPMediaPlacementType.MultiMediaAd100X100]: [EPT.MMA_SquareImage_1x1],
  [UAPMediaPlacementType.MultiMediaAd50X100]: [EPT.MMA_VerticalImage_1x2],

  [UAPMediaPlacementType.MSAN191X100]: [EPT.Audience_Network_WideImage_191x100, EPT.MsanV2_MSAN_River_191x100, EPT.MsanV2_MSAN_Rectangle_Image_191x100],
  [UAPMediaPlacementType.MSAN178X100]: [EPT.Microsoft_Edge_Single_Carousel_178x100],
  [UAPMediaPlacementType.MSAN172X100]: undefined,
  [UAPMediaPlacementType.MSAN169X100]: [EPT.MsanV2_MSN_Carousel_169x100, EPT.PMax_MMAV2_MSN_Single_Carousel_169x100],
  [UAPMediaPlacementType.MSAN155X100]: undefined,
  [UAPMediaPlacementType.MSAN150X100]: [EPT.MSN_InArticle_Ad_150x100],
  [UAPMediaPlacementType.MSAN133X100]: [EPT.MSN_Small_Headline_133x100],
  [UAPMediaPlacementType.MSAN100X100]: [EPT.Audience_Network_SquareImage_1x1, EPT.MsanV2_Microsoft_Edge_Mobile_1x1],
  [UAPMediaPlacementType.MSAN93X100]: undefined,
  [UAPMediaPlacementType.MSAN201X100]: [EPT.MsanV2_Microsoft_Edge_Carouse_l201x100, EPT.PMax_MMAV2_Microsoft_Edge_Single_Carousel_201x100],
  [UAPMediaPlacementType.MSAN200X100]: [EPT.MsanV2_MSAN_Banner_2x1],
  [UAPMediaPlacementType.MSAN153X100]: [EPT.MsanV2_MSN_Partner_Stripe_153x100, EPT.PMax_MMAV2_MSN_Partner_Stripe_153x100],
  [UAPMediaPlacementType.MSAN124X100]: [EPT.MsanV2_MSN_Restoday_124x100, EPT.PMax_MMAV2_MSN_Restoday_124x100],
  [UAPMediaPlacementType.MSAN120X100]: [EPT.MsanV2_MSAN_Rectangle_120x100],

  [UAPMediaPlacementType.ImageExtension191X100]: [EPT.ImgExt_Audience_Network_WideImage_191x100, EPT.ImgExt_MMAV2_MSN_River_191x100],
  [UAPMediaPlacementType.ImageExtension178X100]: [
    EPT.ImgExt_Microsoft_Edge_Single_Carousel_178x100,
    EPT.ImgExt_Bing_Desktop_SingleImage_Extension_178x100,
  ],
  [UAPMediaPlacementType.ImageExtension172X100]: [EPT.ImgExt_Microsoft_Edge_Medium_Headline_172x100],
  [UAPMediaPlacementType.ImageExtension169X100]: [EPT.ImgExt_MSN_Single_Carousel_169x100, EPT.ImgExt_MMAV2_MSN_Single_Carousel_169x100],
  [UAPMediaPlacementType.ImageExtension155X100]: [EPT.ImgExt_MSN_Medium_Headline_155x100],
  [UAPMediaPlacementType.ImageExtension150X100]: [EPT.ImgExt_MSN_InArticle_Ad_150x100],
  [UAPMediaPlacementType.ImageExtension133X100]: [
    EPT.ImgExt_MSN_Small_Headline_133x100,
    EPT.ImgExt_Bing_Desktop_MultiImage_Extension_133x100,
    EPT.ImgExt_Bing_Mobile_MultiImage_Extension_133x100,
  ],
  [UAPMediaPlacementType.ImageExtension100X100]: [EPT.ImgExt_Audience_Network_SquareImage_1x1, EPT.ImgExt_MMAV2_MSN_Microsoft_Edge_Mobile_1x1],
  [UAPMediaPlacementType.ImageExtension93X100]: [EPT.ImgExt_MSN_Double_Carousel_93x100],

  [UAPMediaPlacementType.AssetGroup191X100]: [EPT.PMax_Audience_Network_WideImage_191x100, EPT.PMax_MMA_LandscapeImage_191x100, EPT.PMax_MMAV2_MSN_River_191x100],
  [UAPMediaPlacementType.AssetGroup100X100]: [EPT.PMax_Audience_Network_SquareImage_1x1, EPT.PMax_MMAV2_Microsoft_Edge_Mobile_1x1],
  [UAPMediaPlacementType.AssetGroup150X100]: [EPT.PMax_MSN_InArticle_Ad_150x100],
  [UAPMediaPlacementType.AssetGroup133X100]: [EPT.PMax_MSN_Small_Headline_133x100],
  [UAPMediaPlacementType.AssetGroup178X100]: [EPT.PMax_Microsoft_Edge_Single_Carousel_178x100],
  [UAPMediaPlacementType.AssetGroup100X200]: [EPT.PMax_MMA_VerticalImage_1x2],
  [UAPMediaPlacementType.AssetGroup400X100]: [EPT.PMax_MMA_WideImage_4x1],
};

// multiple placement types may map to the same media placement type
export const PlacementType2MediaPlacementTypeMap = {
  // MMA
  [EPT.MMA_WideImage_4x1]: UAPMediaPlacementType.MultiMediaAd400X100,
  [EPT.MMA_LandscapeImage_191x100]: UAPMediaPlacementType.MultiMediaAd191X100,
  [EPT.MMA_SquareImage_1x1]: UAPMediaPlacementType.MultiMediaAd100X100,
  [EPT.MMA_VerticalImage_1x2]: UAPMediaPlacementType.MultiMediaAd50X100,

  // MSAN
  [EPT.Audience_Network_WideImage_191x100]: UAPMediaPlacementType.MSAN191X100,
  [EPT.Microsoft_Edge_Single_Carousel_178x100]: UAPMediaPlacementType.MSAN178X100,
  [EPT.MSN_InArticle_Ad_150x100]: UAPMediaPlacementType.MSAN150X100,
  [EPT.MSN_Small_Headline_133x100]: UAPMediaPlacementType.MSAN133X100,
  [EPT.Audience_Network_SquareImage_1x1]: UAPMediaPlacementType.MSAN100X100,

  // MSAN V2
  [EPT.MsanV2_Microsoft_Edge_Carouse_l201x100]: UAPMediaPlacementType.MSAN201X100,
  [EPT.MsanV2_MSAN_Banner_2x1]: UAPMediaPlacementType.MSAN200X100,
  [EPT.MsanV2_MSAN_River_191x100]: UAPMediaPlacementType.MSAN191X100,
  [EPT.MsanV2_MSN_Carousel_169x100]: UAPMediaPlacementType.MSAN169X100,
  [EPT.MsanV2_MSN_Partner_Stripe_153x100]: UAPMediaPlacementType.MSAN153X100,
  [EPT.MsanV2_MSN_Restoday_124x100]: UAPMediaPlacementType.MSAN124X100,
  [EPT.MsanV2_MSAN_Rectangle_120x100]: UAPMediaPlacementType.MSAN120X100,
  [EPT.MsanV2_Microsoft_Edge_Mobile_1x1]: UAPMediaPlacementType.MSAN100X100,
  [EPT.MsanV2_MSAN_Rectangle_Image_191x100]: UAPMediaPlacementType.MSAN191X100,

  // pmax
  [EPT.PMax_Audience_Network_WideImage_191x100]: UAPMediaPlacementType.AssetGroup191X100,
  [EPT.PMax_Audience_Network_SquareImage_1x1]: UAPMediaPlacementType.AssetGroup100X100,
  [EPT.PMax_Microsoft_Edge_Single_Carousel_178x100]: UAPMediaPlacementType.AssetGroup178X100,
  [EPT.PMax_MSN_InArticle_Ad_150x100]: UAPMediaPlacementType.AssetGroup150X100,
  [EPT.PMax_MSN_Small_Headline_133x100]: UAPMediaPlacementType.AssetGroup133X100,
  [EPT.PMax_MMA_WideImage_4x1]: UAPMediaPlacementType.AssetGroup400X100,
  [EPT.PMax_MMA_LandscapeImage_191x100]: UAPMediaPlacementType.AssetGroup191X100,
  [EPT.PMax_MMA_VerticalImage_1x2]: UAPMediaPlacementType.AssetGroup100X200,
  // pmax v2
  [EPT.PMax_MMAV2_Microsoft_Edge_Single_Carousel_201x100]: UAPMediaPlacementType.MSAN201X100,
  [EPT.PMax_MMAV2_MSN_Single_Carousel_169x100]: UAPMediaPlacementType.MSAN169X100,
  [EPT.PMax_MMAV2_MSN_Restoday_124x100]: UAPMediaPlacementType.MSAN124X100,
  [EPT.PMax_MMAV2_MSN_Partner_Stripe_153x100]: UAPMediaPlacementType.MSAN153X100,
  [EPT.PMax_MMAV2_MSN_River_191x100]: UAPMediaPlacementType.AssetGroup191X100,
  [EPT.PMax_MMAV2_Microsoft_Edge_Mobile_1x1]: UAPMediaPlacementType.AssetGroup100X100,

  //
  // Image Extension
  [EPT.ImgExt_MMAV2_MSN_River_191x100]: UAPMediaPlacementType.ImageExtension191X100,
  [EPT.ImgExt_Audience_Network_WideImage_191x100]: UAPMediaPlacementType.ImageExtension191X100,

  // ImageExtension178X100
  [EPT.ImgExt_Microsoft_Edge_Single_Carousel_178x100]: UAPMediaPlacementType.ImageExtension178X100,
  [EPT.ImgExt_Bing_Desktop_SingleImage_Extension_178x100]: UAPMediaPlacementType.ImageExtension178X100,

  [EPT.ImgExt_Microsoft_Edge_Medium_Headline_172x100]: UAPMediaPlacementType.ImageExtension172X100,
  [EPT.ImgExt_MSN_Single_Carousel_169x100]: UAPMediaPlacementType.ImageExtension169X100,
  [EPT.ImgExt_MMAV2_MSN_Single_Carousel_169x100]: UAPMediaPlacementType.ImageExtension169X100,
  [EPT.ImgExt_MSN_Medium_Headline_155x100]: UAPMediaPlacementType.ImageExtension155X100,
  [EPT.ImgExt_MSN_InArticle_Ad_150x100]: UAPMediaPlacementType.ImageExtension150X100,

  // ImageExtension133X100
  [EPT.ImgExt_MSN_Small_Headline_133x100]: UAPMediaPlacementType.ImageExtension133X100,
  [EPT.ImgExt_Bing_Desktop_MultiImage_Extension_133x100]: UAPMediaPlacementType.ImageExtension133X100,
  [EPT.ImgExt_Bing_Mobile_MultiImage_Extension_133x100]: UAPMediaPlacementType.ImageExtension133X100,

  [EPT.ImgExt_Audience_Network_SquareImage_1x1]: UAPMediaPlacementType.ImageExtension100X100,
  [EPT.ImgExt_MMAV2_MSN_Microsoft_Edge_Mobile_1x1]: UAPMediaPlacementType.ImageExtension100X100,
  [EPT.ImgExt_MSN_Double_Carousel_93x100]: UAPMediaPlacementType.ImageExtension93X100,
};
